var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8438 34.1471L33.7474 17.3198C33.361 16.6757 32.5437 16.4377 31.8719 16.7736L30.6509 17.3841C30.3742 17.5225 30.04 17.4682 29.8212 17.2494L24.1271 11.5553C23.5243 10.9526 22.5325 11.0038 21.9949 11.6653L7.1875 29.8346V34.1471H43.8438Z",
    fill: "#DBEAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6528 17.3841C30.3761 17.5225 30.0418 17.4682 29.8232 17.2494L29.6099 17.0361L24.6641 33.9452L25.3541 34.147H26.103L31.0667 17.1772L30.6528 17.3841Z",
    fill: "#C3DDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 23.3658L23.6351 11.2329C23.0724 11.0127 22.403 11.1631 21.9949 11.6652L7.1875 29.8345V34.147H17.25V23.3658Z",
    fill: "#C3DDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4859 20.5749C21.9537 20.1121 21.1642 20.1038 20.6224 20.5553L17.25 23.3657L13.2386 21.6465C12.6378 21.389 11.9389 21.5693 11.5376 22.0852L2.15625 34.147H38.0938L22.4859 20.5749Z",
    fill: "#C3DDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2386 21.6466C12.6378 21.3891 11.9389 21.5694 11.5376 22.0853L2.15625 34.1471H22.2812L17.25 23.3658L13.2386 21.6466Z",
    fill: "#A4CCFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2386 21.6466C12.6378 21.3891 11.9389 21.5694 11.5376 22.0853L2.15625 34.1471H7.90625L14.5409 22.2048L13.2386 21.6466Z",
    fill: "#8BB3EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2812 34.8657H0.71875C0.321461 34.8657 0 34.5439 0 34.147C0 33.75 0.321461 33.4282 0.71875 33.4282H45.2812C45.6785 33.4282 46 33.75 46 34.147C46 34.5439 45.6785 34.8657 45.2812 34.8657Z",
    fill: "#C3DDFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.331fd145.svg";
export { ForwardRef as ReactComponent };